const HEX_COLOR_PATTERN = /^#(?:[0-9a-f]{6})$/i;

export const DEFAULT_AUTO_LABEL_COLOR = '#475569';

export function normalizeHexColor(value?: string | null): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  return HEX_COLOR_PATTERN.test(normalized) ? normalized : null;
}

export function getAutoLabelColor(value?: string | null): string {
  return normalizeHexColor(value) ?? DEFAULT_AUTO_LABEL_COLOR;
}
